// @flow
import * as React from 'react';
import { Box, Stack } from '@locus-taxy/neo-ui';

import {
    JsonViewDispatch,
    rankWith,
    uiTypeIs,
    useViewLayoutProps
} from 'platform/settings/form/JsonView';

type Props = {};

const CardContentLayout = (props: Props): React.Node => {
    const {
        uischema,
        schema,
        path,
        renderers,
        cells,
        enabled,
        visible
    } = useViewLayoutProps(props);

    return (
        visible && (
            <Box py={4} px={5}>
                <Stack space="xSmall">
                    {uischema.elements.map((element, index) => (
                        <JsonViewDispatch
                            key={index}
                            uischema={element}
                            schema={schema}
                            path={path}
                            enabled={enabled}
                            renderers={renderers}
                            cells={cells}
                        />
                    ))}
                </Stack>
            </Box>
        )
    );
};

export default CardContentLayout;

export const cardContentLayoutTester = rankWith(
    1,
    uiTypeIs('CardContentLayout')
);
